import { apiClient } from "api";
import { TLocation, TLocationPicklist, TRegionPicklist } from "./models/types";

export const getAllLocationsList = async (accountId: string): Promise<TLocationPicklist[]> => {
  return apiClient.get(`locations/list/${accountId}`).then(response => response.data);
};

export const getAllLocations = async (accountId: string): Promise<TLocation[]> => {
  return apiClient.get(`locations/${accountId}`).then(response => response.data);
};

export const getAllRegionsList = async (accountId: string): Promise<TRegionPicklist[]> => {
  return apiClient.get(`locations/${accountId}/regions/list`).then(response => response.data);
};

export const getLocation = async (
  accountId: string,
  locationId: number
): Promise<TLocation> => {
  const response = await apiClient.get(`locations/edit/${accountId}/${locationId}`);
  return response.data;
};

export const addOrUpdateLocation = async (
  accountId: string,
  location: TLocation,
  isNew: boolean
): Promise<TLocation> => {
  const response = await apiClient({
    method: isNew ? "post" : "put",
    url: `locations`,
    data: { ...location, accountId }
  });
  return response.data;
};
